import React from 'react';

const InvalidTenant = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1 style={{ fontSize: '3rem', color: '#dc3545', marginBottom: '1rem' }}>Invalid Tenant</h1>
      <p style={{ fontSize: '1.2rem', color: '#6c757d', maxWidth: '600px', textAlign: 'center' }}>
        The URL you are trying to access is not associated with a valid institutional account. 
        Please check the URL or contact the administrator if you believe this is an error.
      </p>
    </div>
  );
};

export default InvalidTenant;
